import React, { useEffect, useState } from "react";
import { Box, Button, Divider, IconButton, Modal, TextField, Typography, } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import { useAddUserPerfiles } from "../../../hooks/AdministracionUsuarios/adminPerfiles/addUserPerfiles";

import { sanitizarNombrePerfil, sanitizarDescripcionPerfil, } from "../../../utils/sanitizar";

interface AddPerfilUserProps {
    open: boolean;
    onClose: () => void;
    onSuccess?: () => Promise<void> | void;
}

const AddPerfilUser: React.FC<AddPerfilUserProps> = ({
    open,
    onClose,
    onSuccess,
}) => {

    const {
        agregarPerfil,
        loading,
    } = useAddUserPerfiles();

    const [nombre, setNombre] = useState("");
    const [descripcion, setDescripcion] = useState("");

    const [errorNombre, setErrorNombre] = useState("");
    const [errorDescripcion, setErrorDescripcion] = useState("");

    useEffect(() => {

        if (open) {
            limpiarFormulario();
        }

    }, [open]);

    const cerrarModal = () => {

        limpiarFormulario();

        onClose();

    };

    const guardar = async () => {

        setErrorNombre("");
        setErrorDescripcion("");

        let existeError = false;

        if (!sanitizarNombrePerfil(nombre)) {

            setErrorNombre("Ingresa un nombre válido.");

            existeError = true;

        }

        if (!descripcion.trim()) {

            setErrorDescripcion(
                "La descripción es obligatoria."
            );

            existeError = true;

        }

        if (existeError) {
            return;
        }

        const response = await agregarPerfil({

            nombre: nombre.trim(),
            descripcion: descripcion.trim(),
            estatus: 1,

        });

        if (response) {

            await onSuccess?.();

            cerrarModal();

        }

    };

    const limpiarFormulario = () => {

        setNombre("");
        setDescripcion("");

        setErrorNombre("");
        setErrorDescripcion("");

    };

    return (

        <Modal
            open={open}
            onClose={cerrarModal}
        >

            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "90%",
                    maxWidth: 650,
                    bgcolor: "background.paper",
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 3,
                }}
            >

                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                >

                    <Typography
                        variant="h6"
                        fontWeight="bold"
                    >
                        Agregar Perfil
                    </Typography>

                    <IconButton onClick={cerrarModal}>
                        <CloseIcon />
                    </IconButton>

                </Box>

                <Divider sx={{ mb: 3 }} />

                <Box
                    display="flex"
                    flexDirection="column"
                    gap={3}
                >

                    <TextField
                        fullWidth
                        label="Nombre"
                        value={nombre}
                        error={Boolean(errorNombre)}
                        helperText={errorNombre}
                        onChange={(e) => {

                            const value = sanitizarNombrePerfil(
                                e.target.value
                            );

                            setNombre(value);

                            if (
                                errorNombre &&
                                sanitizarNombrePerfil(value)
                            ) {
                                setErrorNombre("");
                            }

                        }}
                    />

                    <TextField
                        fullWidth
                        multiline
                        minRows={3}
                        label="Descripción"
                        value={descripcion}
                        error={Boolean(errorDescripcion)}
                        helperText={errorDescripcion}
                        onChange={(e) => {

                            const value = sanitizarDescripcionPerfil(
                                e.target.value
                            );

                            setDescripcion(value);

                            if (
                                errorDescripcion &&
                                sanitizarDescripcionPerfil(value)
                            ) {
                                setErrorDescripcion("");
                            }

                        }}
                    />

                </Box>

                <Divider sx={{ my: 3 }} />

                <Box
                    display="flex"
                    justifyContent="flex-end"
                    gap={2}
                >

                    <Button
                        variant="contained"
                        onClick={cerrarModal}
                        sx={{
                            bgcolor: "#F70083",
                            color: "#fff",
                            fontWeight: 600,
                            textTransform: "none",
                            borderRadius: 2,
                            px: 3,
                            "&:hover": {
                                bgcolor: "#D60072",
                            },
                        }}
                    >
                        Cancelar
                    </Button>

                    <Button
                        variant="contained"
                        onClick={guardar}
                        disabled={
                            loading ||
                            !sanitizarNombrePerfil(nombre) ||
                            !descripcion.trim()
                        }
                        sx={{
                            bgcolor: "#2e7d32",
                            color: "#fff",
                            fontWeight: 600,
                            textTransform: "none",
                            borderRadius: 2,
                            px: 3,
                            "&:hover": {
                                bgcolor: "#1b5e20",
                            },
                        }}
                    >
                        {
                            loading
                                ? "Guardando..."
                                : "Guardar Perfil"
                        }
                    </Button>

                </Box>

            </Box>

        </Modal>

    );

};

export default AddPerfilUser;